import StudyList from './StudyList';

export * from './StudyList';
export default StudyList;
